import "./service-category.scss";

import PageTitleBreadcrumb from "@frontend/js/Components/Shared/PageTitleBreadcrumb/PageTitleBreadcrumb";
import ServicesCards from "@frontend/js/Components/Site/ServicesCards/ServicesCards";
import MetaHead from "@frontend/js/Components/Shared/MetaHead/MetaHead";
import SiteLayout from "@frontend/js/Layouts/SiteLayout";
import useT from "@frontend/js/hooks/useT";
import useRoute from "@frontend/js/hooks/useRoute";
import { usePage } from "@inertiajs/react";

export default function ServiceCategory({
    page,
    resource,
    meta = {
        title: "",
        description: "",
    },
}) {
    const { t } = useT("site");
    const route = useRoute();
    const serviceCategory = resource?.data;
    const services = serviceCategory?.cards || [];
    const pageProps = usePage().props;
    const locale = pageProps.currentLocale;
    const content = serviceCategory?.content || "";
    const pageTitle = page?.title?.[locale] || "";
    const pageHref = route("frontend.page", { page: page?.slug });

    return (
        <>
            <MetaHead meta={meta} />

            <SiteLayout>
                <div className="servicePage page-shell">
                    <div className="servicePage__container">
                        <PageTitleBreadcrumb
                            title={serviceCategory?.title}
                            parentTitle={pageTitle}
                            parentHref={pageHref}
                        />

                        <div className="servicesCards">
                            <ServicesCards
                                cards={services}
                                hideLabel
                                getHref={(item) => item.href}
                            />
                        </div>
                        <div className="servicePage__container__text">
                            <h2>{t("services-description-title")}</h2>
                            <div className="servicePage__container__text__description">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: content,
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </SiteLayout>
        </>
    );
}
